import React, {useEffect} from "react"
import ReactHtmlParser from "react-html-parser";
import {withPrefix} from "gatsby"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Link from "@airasia/phoenix-components/components/Link"
import Text from "@airasia/phoenix-components/components/Text"
import Button from "@airasia/phoenix-components/components/Button"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import { UAParser } from 'ua-parser-js'

import UNIVERSAL_HEADER_DATA from "../../data/header"
import HERO_BANNER_DATA from "../../data/my/ms/herobanner"
import FEATURED_HOTELS_CAROUSEL_DATA from "../../data/my/ms/featuredHotels"

import bigpay_superapp_promo_data from "../../data/my/ms/bigpaySuperappPromo"

import Layout from "../../components/layout"
import "../../css/main.css"
import {fireGtmEvent} from "../../utils/functions"

import StickyBox from "../../components/stickyBar"
import MobileFeatures from "../../components/mobileFeatureMS"

import HowToRedeem_DATA from "../../data/my/ms/howToReedem"

import PopularDestination_Data from "../../data/en/popularDestination"

import FAQ from "@airasia/phoenix-widgets/widgets/FAQ"
import FAQ_DATA from "../../data/my/ms/faq"

import exploreMore_DATA from "../../data/my/ms/exploreMore"

import CouponCode from "../../components/couponCode"
import couponCode_Data from "../../data/my/ms/couponCode"

import ContentOnTheLeft from '../../components/ContentOnTheLeft'
import ContentOnTheRight from '../../components/ContentOnTheRight'
import LeftRightContent_Data from "../../data/my/ms/leftRightContent"

// import FSW_DATA from "../../data/FlightSearchWidget";
// import FlightSearchWidget from "@airasia/phoenix-widgets/widgets/FlightSearchWidget"
// import Store from "@airasia/phoenix-widgets/widgets/Store"  

const GreyWrapper = styled.div`
background-color:#f8f8f8;
padding:1em;

`

const ContentWrapper = styled.div`
  width: 100%;
    margin:5em auto;
    max-width: 1208px;
    text-align: center;

#button-gap {margin: 10px;}
#sub-text{
  margin: 0 auto 1.5em; 
  line-height:25px
}
#faq{text-align:left;}
#signup-cta{
  width:30%;
  background-color:#01EA6B;
  color: #023C40;
  border: 1px solid #023C40;
  }

.video-responsive iframe{width:70%;}


  @media only screen and (max-width: 720px) {
    max-width: 625px;
    margin:3em auto;
    width: 80%;

    #signup-cta{width:70%}
    #sub-text{width:100%}
    .video-responsive iframe{width:100%; height: 300px;}
  }
`

const TitleWrapper = styled.div`

  #title {
    color: #ff0000;
    font-weight: 700;
    font-size: 2rem;
    margin-bottom:0.5em;  
  }

  @media only screen and (max-width: 720px) {
    width: 100%;

    #title {
      font-size: 1.6rem;
      line-height:30px;
    }
  }
`

const HowToReedem = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin:0 auto;
  text-align:center;

  @media only screen and (max-width: 400px) {
    width: 100%;
    gap: 10px;
  }
`
const Steps = styled.div`
  display: block;
  width:26%;
  padding:15px;
  margin:1em;
  text-align: center;

  p{line-height:21px;}
  
  @media only screen and (max-width: 480px) {
    width:100%;
    margin: 2em auto;


  }
`

const RoundWrapper = styled.div`
  background-color:#07d1e4;
  color:#fff;
  width:50px;
  height:50px;
  margin:20px auto;
  line-height: 3;
  border-radius:50%;
  
`

const MerchantWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  text-align:center;
  justify-content:center;

  @media only screen and (max-width: 400px) {
    width: 100%;
    gap: 10px;
  }
`

const Merchant = styled.div`
  display: block;
  width:30%;
  margin:1em;
  text-align: center;

  p{line-height:21px;}

  #merchant-image, #howtobook-image  {
    background-color: transparent;
    margin:0em auto;
  }
  
  @media only screen and (max-width: 480px) {
    width:100%;
    margin: 2em auto;

    #merchant-image, #howtobook-image  {
    width:100%;
  }
}
`

const LeftRightSection = styled.div`
  width:100%;
`

const IndexPage = () => {
    const updateLocale = (obj) => {
        window.location.href = withPrefix(obj.detail)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener("uhfLocaleChange", updateLocale)
        }
    }, [])

    let parser = new UAParser();
    console.log(parser.getResult());

    return (
        <Layout title="Kad debit BigPay menawarkan tawaran eksklusif di AirAsia MOVE!"
              canonical="https://www.airasia.com/aa/bigpay/my/ms/"
              description="DISKAUN hingga RM50 dengan BigPay! Jimat untuk penerbangan, hotel, ride dan dapatkan 2x airasia poin dengan AirAsia MOVE. Lihat pelbagai promosi sekarang!"
              bannerData={HERO_BANNER_DATA}
              headerData={UNIVERSAL_HEADER_DATA}
        >
            
            <ContentWrapper>
            <StickyBox/>
          {/* mobile only */}
          <Title
            accessible
            inverted={false}
            textAlign="center"
            theme="AIRASIA_CLASSIC"
            type="h1"
            color="primary"
            customProperties={{id: 'Mobile-title'}}
              >
              Dapatkan Lebih Tawaran & Promosi dengan AirAsia MOVE Dengan Kad Pelancongan Anda, BigPay

           </Title>
           <br/>
          <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="Center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >
                      Beli, hantar duit, jejak perbelanjaan dan lakukan banyak lagi di seluruh dunia dengan kad BigPay Visa. Dengan promosi dan tawaran eksklusif, kad BigPay Visa membolehkan anda kumpul airasia poin untuk penerbangan, servis lain dan produk dengan penjimatan hebat. Nikmati tempahan mudah, diskaun hebat dan pengalaman percutian yang lebih menarik!
                    </Text>

          <anchorLink>
           <Link
              accessible
              color="primary"
              enableQuantumMetrics={false}
              hoverUnderlined
              href="#bigpay-promo"
              quantumMetricType=""
              size="normal"
              target="self"
            >
            Promosi BigPay
            </Link>
            {' '} | {' '}
            <Link
              accessible
              color="primary"
              enableQuantumMetrics={false}
              hoverUnderlined
              href="#exclusive-offers"
              quantumMetricType=""
              size="normal"
              target="self"
            >
            Bagaimana untuk Menghubungkan Akaun
            </Link>
            {' '} | {' '}
            <Link
              accessible
              color="primary"
              enableQuantumMetrics={false}
              hoverUnderlined
              href="#sign-up-bigpay"
              quantumMetricType=""
              size="normal"
              target="self"
            >
            Kenapa Pilih BigPay?
            </Link>
            {' '} | {' '}
            <Link
              accessible
              color="primary"
              enableQuantumMetrics={false}
              hoverUnderlined
              href="#saving-bigpay"
              quantumMetricType=""
              size="normal"
              target="self"
            >
            Tips Menggunakan BigPay
            </Link>
            {' '} | {' '}
            <Link
              accessible
              color="primary"
              enableQuantumMetrics={false}
              hoverUnderlined
              href="#mobile-title"
              quantumMetricType=""
              size="normal"
              target="self"
            >
            Perkhidmatan BigPay
            </Link>
            </anchorLink>
            <br/><br/><br/>
                    
          
          <br/>
            <hr></hr>
            </ContentWrapper>

            <ContentWrapper>
            <Title
                    accessible
                    inverted={false}
                    textAlign="center"
                    type="h2"
                    color
                    marginBottom="XXSmall"
                    color="primary"
                    customProperties={{id: 'bigpay-promo'}}
                >
                    Tawaran khas 2023 BigPay dan AirAsia MOVE!
             </Title>

             <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >
                      Lebih jimat dengan kad debit BigPay apabila anda membeli di AirAsia MOVE. Ketahui promosi di bawah untuk menikmati diskaun terbaik untuk percutian dan gaya hidup.
                    </Text>

                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={bigpay_superapp_promo_data.data}
                    heading={bigpay_superapp_promo_data.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                    newTab={true}
                />
                
                </ContentWrapper>

            <br/><br/>
            {/* <ContentWrapper>
            <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h1"
                        color="primary"
                        marginBottom="XXSmall"
                        
                    >
            Tawaran khas 2023 BigPay dan airasia!
            </Title>
                    <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="Center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >Gunakan BigPay dan nikmati diskaun 5% atas penerbangan airasia dengan kod BIGPAY5<br/>
                       Bayar dengan kad BigPay dan nikmati diskaun 5% atas belian tiket penerbangan AirAsia dengan kod promo BIGPAY5
                    </Text>
                    <br/>
                    {couponCode_Data && (
                      couponCode_Data.map(couponCode_Data => {
                        return (
                        <CouponCode
                        title={couponCode_Data.title}
                        description={couponCode_Data.description}
                        image={couponCode_Data.image}
                        label={couponCode_Data.label}
                        cta={couponCode_Data.cta}
                        url={couponCode_Data.url}
                        /> )
                      }
                ) ) }
                 <Title
                 accessible
                 inverted={false}
                 textAlign="left"
                 theme="AIRASIA_CLASSIC"
                 type="h2"
                        customProperties={{id: ''}}
                    >
                     Syarat & Terma Promosi
                    </Title>
                    <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        display="block"
                        textAlign="left"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: ''}}
                    >
                      <ol><li>Promosi ini dibuka kepada ahli baru dan ahli sedia ada BigPay </li><li>Ahli perlu memasukkan kod promo dalam widget carian penerbangan</li><li>Diskaun 5% boleh dipakai untuk penerbangan AirAsia sahaja</li><li>Tertakluk kepada tempoh 'blackout' </li><li>Tempoh tempahan dan tempoh penerbangan ialah 1 Mac hingga 31 Disember 2023.</li></ol>
                    </Text> 
            </ContentWrapper> */}

<GreyWrapper>
          <ContentWrapper>
          <Title
                        accessible
                        inverted={false}
                        textAlign="center"
                        type="h2"
                        color="primary"
                        marginBottom="XXSmall"
                        customProperties={{id: 'exclusive-offers'}}
                    >
                       Hubungkan BigPay anda ke AirAsia MOVE dan dapatkan pelbagai kelebihan!
                    </Title>

                    <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        display="block"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: ''}}
                    >
                      Tahukah anda kini boleh hubungkan akaun BigPay anda dengan AirAsia MOVE untuk menikmati lebih ganjaran dan faedah? Hubungkan akaun anda sekarang untuk menikmati percutian dengan penuh kemudahan!
                    </Text> 

                    {/* <HowToReedem>
                       {HowToRedeem_DATA &&
                       HowToRedeem_DATA.map(HowToRedeem_DATA => {
                       return (
                       <Steps>
                       <RoundWrapper>
                       <Text
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="p"
                           bold
                           color="default"
                      >
                      {HowToRedeem_DATA.title}
                      </Text>
                      </RoundWrapper>
                      <Text
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="p"
                      >
                      {ReactHtmlParser(HowToRedeem_DATA.subTitle)}
                      </Text>
                      
                      </Steps>
                      )
                    })
                    }
                  </HowToReedem>  */}

                  <br/>
                  <div className="video-responsive">
                    <iframe
                      height="450"
                      src={`https://www.youtube.com/embed/-ziTSVXImmU?si=w91-vwhNYXpX8BRk`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                    />
                  </div>
            
            </ContentWrapper>
            
            <ContentWrapper>
            <hr></hr>
            <br/><br/><br/><br/>
            <Title
                    accessible
                    inverted={false}
                    textAlign="center"
                    type="h2"
                    color="primary"
                    marginBottom="XXSmall"
                    customProperties={{id: 'sign-up-bigpay'}}
                >
                 Daftar dengan BigPay sekarang dan nikmati penjimatan atas belian anda!
             </Title>
             <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >
                       Daftar kad BigPay dan anda akan nikmati diskaun tiket penerbangan, hotel dan ride. Anda boleh dapatkan kadar pertukaran wang lebih baik ketika bercuti! Kad virtual BigPay membolehkan anda belanja secara online apabila anda melepasi sempadan. Pembayaran QR jmembolehkan anda membuat pembayaran di negara luar. Anda juga boleh kumpul poin airasia dan tebus untuk lebih penjimatan.
                    </Text>
                    <br/><br/>
                    
                    <MerchantWrapper>
                       {exploreMore_DATA &&
                       exploreMore_DATA.map(exploreMore_DATA => {
                       return (
                       <Merchant>
                      <Image
                          accessible
                          width="80%"
                          customProperties={{
                          id: "howtobook-image"
                          }}
                          src={exploreMore_DATA.imageUrl} alt={exploreMore_DATA.title}
                       />
                       <br/>
                       <TitleWrapper>
                       <Text
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="p"
                           bold
                           color="primary"
                      >
                      {exploreMore_DATA.title}
                      </Text>
                      <Text
                           accessible
                           inverted={false}
                           textAlign="center"
                           type="p"
                      >
                      {ReactHtmlParser(exploreMore_DATA.subTitle)}
                      </Text>
                      </TitleWrapper>
                      </Merchant>
                      )
                    })
                    }
                  </MerchantWrapper> 
                  </ContentWrapper>

                    
            <ContentWrapper>
                    <Button
                        accessible
                        backgroundColor="default"
                        boxShadow
                        buttonType="link"
                        cardIndex={0}
                        color="primary"
                        defaultDisabledFeatures
                        disabled={false}
                        fontWeight="normal"
                        size="normal"
                        target="tab"
                        type="normal"
                        href="https://bigpayme.com/"
                        customProperties={{id: 'signup-cta'}}
                      >
                        Daftar sekarang!
                      </Button>

             </ContentWrapper>
             </GreyWrapper>

             <ContentWrapper>
             <Title
                    accessible
                    inverted={false}
                    textAlign="center"
                    type="h2"
                    color="primary"
                    marginBottom="XXSmall"
                    customProperties={{id: 'saving-bigpay'}}
                >
                Tips Jimat Dengan BigPay Ketika Melancong
             </Title>
             <Text
                  accessible
                  hasToggle={false}
                  opacity={1}
                  tag="p"
                  textAlign="center"
                  theme="AIRASIA_CLASSIC"
                  type="default"
                  customProperties={{id: 'sub-text'}}
              >
                  Jimat dengan BigPay ketika anda melancong! Kad diterima di lebih dari 40 juta peniaga di seluruh dunia, buat pembelian tanpa tunai dan kesan perbelanjaan dengan mudah. Anda akan menerima pelbagai tawaran penerbangan, hotel, ride dan banyak lagi! Nikmati kadar pertukaran forex lebih baik untuk pejimatan dan dapatkan poin untuk setiap transaksi yang boleh ditebus untuk penerbangan dan produk lain di AirAsia MOVE.
              </Text>
             <LeftRightSection>
                
                {LeftRightContent_Data && (
                      LeftRightContent_Data.map(LeftRightContent_Data => {
                          if (LeftRightContent_Data.imagePosition === "Right") {
                              return (
                              <ContentOnTheRight
                              IconContentRight={LeftRightContent_Data.imagePosition}
                              title={LeftRightContent_Data.title}
                              text={LeftRightContent_Data.text}
                              image={LeftRightContent_Data.image}
                              /> )
                          }
                          else{
                              return (
                                  <ContentOnTheLeft
                                  IconContentRight={LeftRightContent_Data.imagePosition}
                                  title={LeftRightContent_Data.title}
                                  text={LeftRightContent_Data.text}
                                  image={LeftRightContent_Data.image}
                                  />   )
                          }
                      })
                  )}
                   </LeftRightSection>
                  <br/><br/>
                  <Text
                      accessible
                      hasToggle={false}
                      opacity={1}
                      tag="p"
                      textAlign="center"
                      theme="AIRASIA_CLASSIC"
                      type="default"
                      customProperties={{id: 'sub-text'}}
                  >
                      Kad BigPay harus dimiliki semua! Dengan kadar pertukaran matawang asing terbaik dan penerimaan di seluruh dunia, ianya memudahkan kewangan anda biarpun di negara sendiri atau di negara asing. Jadilah ahli sekarang dan nikmati semua keistimewaan kad BigPay!
                  </Text>
             </ContentWrapper>
            
            <ContentWrapper>
            <Title
            accessible
            inverted={false}
            textAlign="center"
            theme="AIRASIA_CLASSIC"
            type="h3"
            customProperties={{id: 'mobile-title'}}
              >
                Ketahui Lebih Lanjut Mengenai Kadar BigPay dan Servis Lain:
           </Title>
           
          <MobileFeatures/>
          <br/><br/><br/>
          <hr></hr>
            </ContentWrapper>
            <ContentWrapper>
            <Title
                    accessible
                    inverted={false}
                    textAlign="center"
                    type="h2"
                    color
                    marginBottom="XXSmall"
                    color="primary"
                    customProperties={{id: 'saving-bigpay'}}
                >
                    Semak lebih banyak ganjaran yang tersedia di laman promosi airasia
             </Title>

             <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >
                       Layari laman promosi airasia dan semak pelbagai tawaran dan promosi yang kami sajikan untuk anda.
                    </Text>

                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={FEATURED_HOTELS_CAROUSEL_DATA.data}
                    heading={FEATURED_HOTELS_CAROUSEL_DATA.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                    newTab={true}
                />
                
                </ContentWrapper>

                <ContentWrapper>
            <Title
                    accessible
                    inverted={false}
                    textAlign="center"
                    type="h2"
                    color
                    marginBottom="XXSmall"
                    color="primary"
                    customProperties={{id: ''}}
                >
                    Menjelajah Lebih Jauh Dengan Penjimatan Hebat Dengan BigPay
             </Title>

             <Text
                        accessible
                        hasToggle={false}
                        opacity={1}
                        tag="p"
                        textAlign="center"
                        theme="AIRASIA_CLASSIC"
                        type="default"
                        customProperties={{id: 'sub-text'}}
                    >
                       Jelajahi lebih jauh dengan penjimatan besar dengan kad BigPay. Dengan ciri-ciri istimewa seperti kadar pertukaran mata wang asing terbaik, penerimaan di seluruh dunia dan ciri keselamatan yang mantap, teruskan melancong ke banyak negara asing. Manfaatkan perjalanan anda sebaik mungkin sambil menjimat lebih banyak. Jadilah ahli BigPay sekarang!
                    </Text>

                    <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={PopularDestination_Data.data}
                    heading={PopularDestination_Data.heading}
                    // customProperties={{id: 'captain'}}
                    templateType="GalleryCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                    newTab={true}
                    width="180px"
                    height="250px"
                    cardConfig={{
                      cardHeaderHeight: '250px',
                      borderRadius: '4px 4px 0px 0px',
                      color: 'default',
                      customOverlayProperties: {
                        overlayBackground: 'linear-gradient(0deg, #000000 4.3%, rgba(0, 0, 0, 0) 96.12%)',
                        overlayHeight: '50%',
                        overlayZIndex: '1'
                      },
                      hasOverlay: true,
                    }}
                    customProperties={{
                      'height': '250px'
                    }}
                />
                
                </ContentWrapper>
            
            <ContentWrapper>
              <TitleWrapper>
            <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h2"
                        customProperties={{id: 'sub-title'}}
                    >
                        Soalan Lazim
                    </Title>
                    </TitleWrapper>
                    <br/>
                <FAQ
                    data={FAQ_DATA}
                    displayIndex={false}
                    size={{}}
                    theme="AIRASIA_CLASSIC"
                    titleAlign="left"
                    textAlign="left"
                    titleMarginBottom="normal"
                    titleType="h3"
                    customProperties={{id: 'faq'}}
                />
                </ContentWrapper>

           

          {/* <Download>
            <DownloadContent>
              <AppDownload>
                <Text
                  accessible
                  color="default"
                  display="inlineFlex"
                  hasToggle={false}
                  opacity={1}
                  tag="p"
                  theme="AIRASIA_CLASSIC"
                  translation={{}}
                  type="default"
                  customProperties={{
                    id: "app-download-text"
                  }}
                >
                  Explore airasia Super App
                </Text>
                <DownloadAppWrapper>
                  <DownloadApp>
                    <Link href="https://airasia.onelink.me/F4uy/0hxr8hu5">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/app-store-badge.png" alt="AirAsia Mobile App - IOS"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://airasia.onelink.me/F4uy/0hxr8hu5">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/google-play-badge.png"
                        alt="AirAsia Mobile App - Google Play"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://airasia.onelink.me/F4uy/0hxr8hu5 ">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/huawei-app-gallery-badge.png"
                        alt="AirAsia Mobile App - HuaWei"
                      />
                    </Link>
                  </DownloadApp>
                </DownloadAppWrapper>
              </AppDownload>
              <SuperAppIconWrapper>
                <Image
                  accessible
                  width="90px"
                  customProperties={{
                    id: "superapp-image"
                  }}
                  src="https://www.airasia.com/aa/ride/images/super-app.png"
                  alt="airasia, The Asean Super App" />
              </SuperAppIconWrapper>
              <DownloadButtonWrapper>
                <Button
                  accessible
                  buttonType="link"
                  customProperties={{
                    id: "buttonDownload",
                    paddingBottom: "1rem",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    paddingTop: "1rem"
                  }}
                  fontWeight="normal"
                  href="https://airasia.onelink.me/F4uy/8102dac5"
                  size="normal"
                  target="tab"
                  type="normal"
                  color="default"
                  backgroundColor="#fff"
                  hoverBackgroundColor="default"
                  hoverColor="primary"
                >
                  Download Now
                </Button>
              </DownloadButtonWrapper>
            </DownloadContent>
          </Download> */}
        </Layout>
    )
}
export default IndexPage
